import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatRadioModule } from '@angular/material/radio';
import { PowerplatformAgentActionConfirmationMode } from 'src/app/services/httpServices/actionsHttpService/actions-http-service.service';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import { AutonomousWithTriggersComponent } from '../../common/autonomous-with-triggers/autonomous-with-triggers.component';
import { IAutonomousWithTriggersComponent } from '../../common/interfaces/autonomous-with-triggers.interface';

@Component({
  selector: 'app-set-confirmation-mode',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule, MatRadioModule, LabelsProviderPipe, AutonomousWithTriggersComponent],
  templateUrl: './set-confirmation-mode.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SetConfirmationModeComponent implements IAutonomousWithTriggersComponent {
  public fg = input.required<UntypedFormGroup>();
  public selectedConfirmationMode = model.required<PowerplatformAgentActionConfirmationMode>();
  public labelKey = input.required<string>();
  public confirmationModeOptions = PowerplatformAgentActionConfirmationMode;
  public ignoreIfAutonomousWithTriggers = model.required<boolean>();

  // Properties expected by the template
  public confirmationMode = this.selectedConfirmationMode;
  public confirmationModeEnum = PowerplatformAgentActionConfirmationMode;

  public getLabelKey(): string {
    return this.labelKey();
  }

  public onRadioButtonChange(value: PowerplatformAgentActionConfirmationMode): void {
    this.selectedConfirmationMode.set(value);
  }
}
